export default {
    subtitle: "Information needed for registration (Companies) ",
		path: "company_registration",
    paragraph: "The following endpoint is used to register new companies, regardless of nationality. If a document number has been previously registered, the company details will be updated. As soon as you send the request to register a company, you will receive a response with their 'subject_id'.",
    request: {
			method: "POST", 
			endpoint: "/subject/companies",
			payload: {
				"company": {
					"document_number": "45215604065562",
					"document_type": "cnpj",
					"social_name": "Company Social Name LTDA",
					"company_name": "Company Fantasy Name",
					"email": "company@email.com",
					"website": "https://www.companywebsite.com",
					"phone_country_code": "55",
					"phone_area_code": "18",
					"phone_number": "99812-1212",
					"creation_date": "2015-04-01",
					"address_street": "Rua Barão do Rio Branco",
					"address_number": "310",
					"address_complement": "",
					"address_postal_code": "16201220",
					"address_city": "Birigui",
					"address_state": "SP",
					"address_country": "BR",
					"fiscal_country": "Brasil",
					"net_monthly_average_income": "4000",
					"net_value": "10000",
					"main_activity": "8599603 - Treinamento em informática",
					"activity_type": "other",
					"company_type": "ltda",
					"documents": [
						{
							"file_type": "application/pdf",
							"file_url": "http://somedomain.com/document-x.pdf",
							"labels": [
								"social-contract"
							]
						}
					],
					"partners": [
						{
							"document_number": "92331064322",
							"document_type": "CPF/CNPJ/TAXID",
							"kind": "person",
							"name": "Manoel Silvares",
							"percentage_share": "50",
							"address_country": "BR"
						}
					]
				}
			},
		responses: {
			"data": {
				"updated_at": "2021-04-28T23:55:15.381004",
				"status": "approved",
				"social_name": "Company Social Name LTDA",
				"required_clearance_level": 1,
				"references": [],
				"phone_number": "99812-1212",
				"partners": [
					{
						"percentage_share": "50",
						"name": "Manoel Silvares",
						"kind": "person",
						"id": "ce05676e-5ba9-4d38-b081-b978729772ae",
						"documents": [],
						"document_type": "CPF/CNPJ/TAXID",
						"document_number": "92331064322",
						"address_country": "BR"
					}
				],
				"net_value": "10000.00",
				"net_monthly_average_income": "4000.00",
				"main_activity": "8599603 - Treinamento em informática",
				"inserted_at": "2021-03-11T19:29:29.785250",
				"id": "577ff176-cbc4-4490-ad70-9a8d1a1d4006",
				"fiscal_country": "Brasil",
				"email": "company@email.com",
				"website": "https://www.companywebsite.com",
				"documents": [
					{
						"labels": [
							"social-contract"
						],
						"id": "58fc5430-6ed1-4b90-ae09-d21e47839370",
						"file_url": "http://somedomain.com/document-x.pdf",
						"file_type": "application/pdf"
					}
				],
				"document_type": "cnpj",
				"document_number": "45215604065562",
				"creation_date": "2015-04-01",
				"company_type": "ltda",
				"company_name": "Company Fantasy Name",
				"clearance_level": 1,
				"address_street": "Rua Barão do Rio Branco",
				"address_state": "SP",
				"address_postal_code": "16201220",
				"address_number": "310",
				"address_country": "BR",
				"address_complement": null,
				"address_city": "Birigui",
				"activity_type": "other"
			}
		}
	},
	parameterPayload: [
		{
			name: "company",
			type: "object",
			required: true,
			description: "An object containing all the required values needed"
		},
		{
			name: "company.document_number",
			type: "string",
			required: true,
			description: "Company's national document number",
			requiredFor: "All transactions"
		},
		{
			name: "company.document_type",
			type: "string",
			required: true,
			description: "Company’s type of document",
			requiredFor: "All transactions"
		},
		{
			name: "company.social_name",
			type: "string",
			required: true,
			description: "Company's social name",
			requiredFor: "All transactions"
		},
		{
			name: "company.fiscal_country",
			type: "string",
			required: true,
			description: "Name of country where the company is registered Ex.: Brasil, Colombia, Chile, Mexico",
			requiredFor: "All transactions"
		},
		{
			name: "company.email",
			type: "string",
			required: false,
			description: "Company's e-mail address",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.website",
			type: "string",
			required: false,
			description: "Company's website"
		},
		{
			name: "company.phone_country_code",
			type: "string",
			required: false,
			description: "Country phones code (2 digits: BR +55; MX +52; COP +57; CL +52)",
			requiredFor: "Cards transactions in MXN and for PSE"
		},
		{
			name: "company.phone_area_code",
			type: "string",
			required: false,
			description: "Internal country area code",
      requiredFor: "PSE transactions"
		},
		{
			name: "company.phone_number",
			type: "string",
			required: false,
			description: "Company's phone number",
			requiredFor: "Cards and PSE transactions"
		},
		{
			name: "company.creation_date",
			type: "string",
			required: false,
			description: "Company's creation date (yyyy-mm-dd format)"
		},
		{
			name: "company.net_monthly_average_income",
			type: "string",
			required: false,
			description: "Company's net monthly average income"
		},
		{
			name: "company.address_street",
			type: "string",
			required: false,
			description: "Company's street name",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.address_number",
			type: "string",
			required: false,
			description: "Company's address number",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.address_complement",
			type: "string",
			required: false,
			description: "Company's complement"
		},
		{
			name: "company.address_neighborhood",
			type: "string",
			required: false,
			description: "Company’s neighborhood/district",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.address_postal_code",
			type: "string",
			required: false,
			description: "Postal/ZIP code",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.address_city",
			type: "string",
			required: false,
			description: "Company’s city name",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.address_state",
			type: "string",
			required: false,
			description: "Company’s state of residence",
			requiredFor: "Cards, PSE and boleto transactions"
		},
		{
			name: "company.address_country",
			type: "string",
			required: false,
			description: "An ISO 3166-1 alpha-2 country code of the company's address country"
		},
				{
			name: "company.main_activity",
			type: "string",
			required: false,
			description: "Company’s segment, main market"
		},
		{
			name: "company.activity_type",
			type: "string",
			required: false,
			description: "Activity type"
		},
		{
			name: "company.net_value",
			type: "number",
			required: false,
			description: "Company’s net value"
		},
		{
			name: "company.company_type",
			type: "string",
			required: false,
			description: "Company’s type",
			requiredFor: "All transactions"
		},
		{
			name: "company.partners",
			type: "array",
			required: false,
			description: "An array of objects containing the following values, each one:",
			isParent: true
		},
		{
			name: "company.partners.document_number",
			type: "string",
			required: false,
			description: "Document number",
			requiredFor: "When sending partners field"
		},
		{
			name: "company.partners.document_type",
			type: "string",
			required: false,
			description: "Type of document² of the partner",
			requiredFor: "When sending partners field"
		},
		{
			name: "company.partners.kind",
			type: "string",
			required: false,
			description: "Partner type",
			requiredFor: "When sending partners field",
		},
		{
			name: "company.partners.name",
			type: "string",
			required: false,
			description: "Partner Name",
			requiredFor: "When sending partners field"
		},
		{
			name: "company.partners.percentage_share",
			type: "string",
			required: false,
			description: "Partner percentage of shares in the company",
			requiredFor: "When sending partners field"
		},
		{
			name: "company.partners.address_country",
			type: "string",
			required: false,
			description: "An ISO 3166-1 alpha-2 country code of the address country",
			requiredFor: "When sending partners field"
		},
		{
			name: "company.documents",
			type: "array",
			required: false,
			description: "An array of documents related to the customer (Cutomers who operate above a threshold value per month or exceed a cumulative limit in the last 12 months of operation must have the following associated documents: 'rg-number', 'cpf-number', 'rg-photo', 'address-proof', 'revenue-tax-declaration').",
			isParent: true,
			requiredFor: "Customer who exceeds 20k USD annually in their amount of transactions"
		},
		{
			name: "company.documents.labels",
			type: "array",
			required: false,
			description: "Keywords that may help identify the document in the company registration tab.",
      requiredFor: "When sending documents field"
		},
		{
			name: "company.documents.file_type",
			type: "string",
			required: false,
			description: "Document file MIME type. Must match the document type.",
      requiredFor: "When sending documents field"
		},
		{
			name: "company.documents.file_data",
			type: "string",
			required: false,
			description: "Document file encoded in Base64.",
      requiredFor: "When sending documents and using the file_data"
		},
    {
      name: "company.documents.file_name",
      type: "string",
      required: false,
      description: "Name which the file will be stored.",
      requiredFor: "When sending documents field and using the file_data"
    },
		{
			name: "company.documents.file_url",
			type: "string",
			required: false,
			description: "Public URL pointing to the document. Note that it must start with http:// or https://",
      requiredFor: "When sending documents and using a URL"
		}
	]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesRegistration.js